import request from "@/utils/request";

// 我的投递
export function sendAnnex(page) {
    return request({
        url: 'member/sendAnnex',
        method: 'post',
        data:{
            page:page
        }
    })
}
// 沟通过
export function chatListV2(page) {
    return request({
        url: 'chat/chatListV2',
        method: 'post',
        data:{
            page:page
        }
    })
}
// 待面试 category:1未开始 2已结束
export function getInterviewList(page,category) {
    return request({
        url: 'Interview/getInterviewList',
        method: 'post',
        data:{
            page:page,
            category:category
        }
    })
}
// 浏览记录
export function userLookJob(page) {
    return request({
        url: 'member/userLookJob',
        method: 'post',
        data:{
            page:page
        }
    })
}
// 我的收藏 column ：job职位 company企业
export function memberCollectionList(page,column) {
    return request({
        url: 'Collection/memberCollectionList',
        method: 'post',
        data:{
            page:page,
            column:column
        }
    })
}
// 谁浏览了我
export function seeMeNew(page) {
    return request({
        url: 'Interaction/seeMeNew',
        method: 'get',
        params:{
            page:page
        }
    })
}
// 取消面试
export function cancelInterview(id) {
    return request({
        url: 'Interview/cancelInterview',
        method: 'post',
        data:{
            inter_id:id,
            cancel_reason:'我想取消面试'
        }
    })
}
// accept同意或拒refuse绝面试
export function acceptInterview(id,status) {
    return request({
        url: 'Interview/acceptInterview',
        method: 'post',
        data:{
            inter_id: id,
            status: status
        }
    })
}

// 个人中心数据
export function myCenterParams() {
    return request({
        url: 'v2/resume/getActivityMessage',
        method: 'get',
    })
}